import React, { useMemo } from 'react';
import { TAdditionalApplications } from 'types';
import { additionalApplications } from 'appConstants';
import { ISelectOption } from 'components/Select/types';
import FormSelect from 'components/Select/FormSelect';
import style from './AdditionalApplicationsMultipleSelect.module.scss';

interface IAdditionalApplicationsMultipleSelect {
	setAdditionalApplications(value: TAdditionalApplications[]): void;
}

const AdditionalApplicationsMultipleSelect: React.FC<IAdditionalApplicationsMultipleSelect> = ({
	setAdditionalApplications,
}) => {
	const mappedOptions = useMemo<ISelectOption[]>(() => {
		return additionalApplications.map((el) => ({
			id: el.additionalApplicationID,
			name: el.additionalApplicationName,
		}));
	}, [additionalApplications]);

	const handleChange = (value: TAdditionalApplications[]) => {
		setAdditionalApplications(value);
	};

	return (
		<FormSelect
			containerClassName={style.select}
			testId="AdditionalApplicationsMultipleSelect"
			name="additionalApplications"
			label="additionalApplicationsLabel"
			options={mappedOptions || []}
			onChange={handleChange}
			mode="multiple"
			showSearch={false}
		/>
	);
};

export default React.memo(AdditionalApplicationsMultipleSelect);
